import { defineMessages } from "react-intl";
import { stdnum } from "stdnum";

import { removeNonAlphanumeric } from "../tax-information.utils";

const US_TAX_IDS = {
  EIN: "EIN",
  SSN_ITIN: "SSN_ITIN",
};

const US_TAX_IDS_META = {
  [US_TAX_IDS.EIN]: {
    type: US_TAX_IDS.EIN,
    ...defineMessages({
      shortNameMessageDescriptor: {
        id: "hosting.tax_information_section.ein_short_name",
        defaultMessage: "EIN",
      },
      nameMessageDescriptor: {
        id: "hosting.tax_information_section.ein_name",
        defaultMessage: "Employer Identification Number",
      },
      fullNameMessageDescriptor: {
        id: "hosting.tax_information_section.ein_full_name",
        defaultMessage: "Employer Identification Number (EIN)",
      },
    }),
    validationFn: stdnum.US.ein.validate,
    format: "00-0000000",
    ...defineMessages({
      formatStringMessageDescriptor: {
        id: "hosting.tax_information_section.ein_format",
        defaultMessage: "9-digit",
      },
    }),
  },
  [US_TAX_IDS.SSN_ITIN]: {
    type: US_TAX_IDS.SSN_ITIN,
    ...defineMessages({
      shortNameMessageDescriptor: {
        id: "hosting.tax_information_section.ssn_itin_short_name",
        defaultMessage: "SSN/ITIN",
      },
      nameMessageDescriptor: {
        id: "hosting.tax_information_section.ssn_itin_name",
        defaultMessage:
          "Social Security Number or Individual Taxpayer Identification Number",
      },
      fullNameMessageDescriptor: {
        id: "hosting.tax_information_section.ssn_itin_full_name",
        defaultMessage:
          "Social Security Number or Individual Taxpayer Identification Number (SSN/ITIN)",
      },
    }),
    validationFn: (value) => {
      // ITIN
      const validationPattern =
        /^9\d{2}[- ]?(7[0-9]|8[0-8]|9[0-2]|9[4-9])[- ]?\d{4}$/;
      const isITINValid = validationPattern.test(value);
      // SSN
      const ssn = stdnum.US.ssn.validate(value);
      return isITINValid
        ? {
            isValid: isITINValid,
            compact: removeNonAlphanumeric(value),
            isIndividual: false,
            isCompany: true,
          }
        : ssn;
    },
    format: "000-00-0000",
    ...defineMessages({
      formatStringMessageDescriptor: {
        id: "hosting.tax_information_section.ssn_itin_format",
        defaultMessage: "9-digit",
      },
    }),
  },
};

export { US_TAX_IDS, US_TAX_IDS_META };
